import { api } from './client';
import {
  planViewSchema,
  plansResponseSchema,
  type CreatePlanRequest,
  type PlanView,
  type PlansResponse,
  type UpdatePlanRequest,
} from './types';

export async function listPlans(): Promise<PlansResponse> {
  const body = await api.get<unknown>('/plans');
  return plansResponseSchema.parse(body);
}

export async function createPlan(request: CreatePlanRequest): Promise<PlanView> {
  const body = await api.post<unknown>('/plans', request);
  return planViewSchema.parse(body);
}

export async function updatePlan(planId: string, request: UpdatePlanRequest): Promise<PlanView> {
  const body = await api.put<unknown>(`/plans/${planId}`, request);
  return planViewSchema.parse(body);
}

export async function archivePlan(planId: string): Promise<PlanView> {
  const body = await api.post<unknown>(`/plans/${planId}/archive`);
  return planViewSchema.parse(body);
}
